import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { CoursesService } from '../../courses.service';
import { ProgressService } from '../../progress.service';
import * as _ from 'underscore';
import { JwplayerDirective } from '../../jwplayer.directive';
import { CourseGroupCardComponent } from '../../components/course-group-card/course-group-card.component';
import {AuthContextService} from '../../services/auth-context.service';

@Component({
  selector: 'app-learn',
  templateUrl: './learn.component.html',
  styleUrls: ['./learn.component.scss']
})
export class LearnComponent implements OnInit {

  loading = true;

  ownedCourseGroups: any[] = new Array();
  unownedCourseGroups: any[] = new Array();
  courseGroups: any[] = new Array();
  tags: any[] = new Array();

  showAllCourses = true;
  selectedTags: any[] = new Array();
  showing = 'ALL';

  constructor(
    private router: Router,
    private authContextService: AuthContextService,
    private coursesService: CoursesService,
    private progressService: ProgressService
  ) {
    console.log('LearnComponent.constructor');
  }

  ngOnInit() {
    this.loadCourses();
  }

  show($event, tag) {
    $event.preventDefault();
    this.showing = tag;
    this.showAllCourses = false;
    this.selectedTags = [tag];
  }

  showAll($event) {
    $event.preventDefault();
    this.showing = 'ALL';
    this.showAllCourses = true;
    this.selectedTags = this.tags;
  }

  loadCourses() {
    const user = this.authContextService.user;

    this.loading = true;
    const initialData = {
      tags: this.tags,
      selectedTags: this.selectedTags
    };
    this.coursesService.loadCourses(initialData, user).then((result: any) => {
      this.tags = result.tags;
      this.selectedTags = result.selectedTags;
      this.ownedCourseGroups = result.ownedCourseGroups;
      this.unownedCourseGroups = result.unownedCourseGroups;
      this.courseGroups = result.courseGroups;
      this.loading = false;
    });
  }
}
